import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { TicketsBoard } from '@models';

@Injectable({ providedIn: 'root' })
export class TicketsBoardService extends CrudService<TicketsBoard> {
  constructor() {
    super('tickets-boards', TicketsBoard);
  }
}

